import { cn } from './cn.js';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZES: Record<SpinnerSize, string> = {
  sm: 'w-3.5 h-3.5 border',
  md: 'w-5 h-5 border-2',
  lg: 'w-8 h-8 border-2',
};

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  /** Accessible label; omit for purely decorative spinners inside a labelled control. */
  label?: string;
}

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn(
        'inline-block rounded-full border-current border-r-transparent animate-spin align-[-0.125em]',
        SIZES[size],
        className,
      )}
    />
  );
}
